import React, { useState, useEffect } from "react";

const Livepage = () => {
  const [activeDashboard, setActiveDashboard] = useState(null);
  const [iframeLoading, setIframeLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const colleges = [
    {
      name: "MGIT",
      themeColor: "from-amber-400/20 to-orange-500/20",
      accent: "#f59e0b",
      projects: [
        { id: "cems", label: "CEMS", url: "https://script.google.com/macros/s/AKfycbyhCFeXWwwm5DmI0zxtV6elDkHMkW5ckdm0laBI8j4NDl8HxEsoJrxS1OUFfGcUFFw8/exec" },
        { id: "ups", label: "UPS MONITORING", url: "https://script.google.com/macros/s/AKfycbw0qnLqjw1CrWZ0XtZpV3zHhpc0DTZoXsFvpv23JqFNq7cPadtRYjdVuVPXeaTkF4A/exec" }
      ],
      logo: "/deployimage/mgit.png",
      status: "ONLINE",
      location: "Gandipet, Hyderabad, Telangana, 500075",
    },
    {
      name: "BVRIT",
      themeColor: "from-blue-400/20 to-indigo-500/20",
      accent: "#3b82f6",
      projects: [{ id: "cems", label: "CEMS", url: "https://script.google.com/a/macros/bvrit.ac.in/s/AKfycbzOJ-SVDoeMyLf8jjFDkuy6QhOqSzvMaWJnx7KZDlmuqTNzGUCmPX3MckRkJ71NeeLD3Q/exec" }],
      logo: "/deployimage/bvrit.png",
      status: "ONLINE",
      location: "Narsapur, Medak District - 502313",
    },
    {
      name: "CBIT",
      themeColor: "from-emerald-400/20 to-teal-500/20",
      accent: "#10b981",
      projects: [{ id: "cems", label: "CEMS", url: "" }],
      logo: "/deployimage/cbit.png",
      status: "UNDER INTEGRATION",
      location: "Gandipet, Hyderabad, Telangana, 50007",
    },
    {
      name: "BITS",
      themeColor: "from-rose-400/20 to-red-500/20",
      accent: "#f43f5e",
      projects: [{ id: "cems", label: "CEMS", url: "https://bitsw-cems.vercel.app/" }],
      logo: "/deployimage/bits.png",
      status: "OFFLINE",
      location: "Warangal - 506331, Telangana",
    },
  ];

  const [selectedProject, setSelectedProject] = useState({});

  useEffect(() => {
    if (!activeDashboard) return;
    const interval = setInterval(() => setRefreshKey(k => k + 1), 60000);
    return () => clearInterval(interval);
  }, [activeDashboard]);

  const handleLaunch = (college) => {
    const projectId = selectedProject[college.name] || "cems";
    const project = college.projects.find(p => p.id === projectId);
    if (!project?.url) return;
    setIframeLoading(true);
    setActiveDashboard({ ...college, activeUrl: project.url, activeLabel: project.label });
  };

  return (
    <div className="relative min-h-screen bg-[#010409] text-white overflow-hidden font-sans selection:bg-amber-500/30">
      
      {/* 🌌 HERO MESH BACKGROUND */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-[-20%] left-[-10%] w-[900px] h-[900px] bg-amber-500/20 rounded-full blur-[140px] animate-mesh" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[800px] h-[800px] bg-blue-600/20 rounded-full blur-[130px] animate-mesh animation-delay-2000" />
        <div className="absolute top-[20%] right-[15%] w-[600px] h-[600px] bg-emerald-500/15 rounded-full blur-[120px] animate-mesh animation-delay-4000" />
      </div>

      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-[0.05] pointer-events-none" />
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff03_1px,transparent_1px),linear-gradient(to_bottom,#ffffff03_1px,transparent_1px)] bg-[size:40px_40px]" />

      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center py-12 px-6">
        {activeDashboard ? (
          /* ================= FULLSCREEN DASHBOARD VIEW ================= */
          <div className="w-full max-w-[95%] h-[90vh] flex flex-col animate-pageIn">
            <nav className="flex items-center justify-between glass-hero px-6 py-3 rounded-2xl mb-4 border border-white/10 shadow-2xl">
              <div className="flex items-center gap-4">
                <button onClick={() => setActiveDashboard(null)} className="p-2 bg-white/5 rounded-xl hover:bg-white/10 border border-white/5 transition-all group">
                   <svg className="w-5 h-5 text-white group-hover:text-amber-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7"/></svg>
                </button>
                <div className="space-y-0.5">
                  <h2 className="text-[9px] font-black tracking-[0.4em] text-amber-500 uppercase leading-none">{activeDashboard.name} NODE</h2>
                  <p className="text-sm font-black text-white italic tracking-tight">{activeDashboard.activeLabel}</p>
                </div>
              </div>
              <button onClick={() => window.open(activeDashboard.activeUrl, "_blank")} className="text-[9px] font-black tracking-[0.3em] px-6 py-2.5 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all">
                FULL SOURCE ↗
              </button>
            </nav>

            <div className="flex-1 rounded-[2.5rem] overflow-hidden border border-white/10 bg-black shadow-3xl relative">
              {iframeLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-[#010409]/95 z-20 backdrop-blur-xl">
                   <div className="flex flex-col items-center gap-4">
                      <div className="w-10 h-10 border-2 border-amber-500/20 border-t-amber-500 rounded-full animate-spin" />
                      <p className="text-[10px] font-black tracking-[0.4em] text-amber-500 animate-pulse">ESTABLISHING LINK</p>
                   </div>
                </div>
              )}
              <iframe key={refreshKey} src={activeDashboard.activeUrl} title="Live Feed" className="w-full h-full brightness-[0.85] contrast-[1.1]" onLoad={() => setIframeLoading(false)} />
            </div>
          </div>
        ) : (
          /* ================= PROFESSIONAL HERO LANDING ================= */
          <div className="w-full max-w-6xl animate-pageIn">
            <header className="text-center mb-16">
              <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-white/5 border border-white/10 shadow-lg">
                <span className="text-amber-500 text-[10px] font-black tracking-[0.5em] uppercase opacity-80">Telemetry Control Center</span>
              </div>
              <h1 className="text-5xl md:text-8xl font-black tracking-tighter italic mb-3">
                <span className="text-white">POWERSENSE</span> <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500">LIVE</span>
              </h1>
              <p className="text-[11px] font-bold tracking-[0.6em] text-white/40 uppercase">Infrastructure Monitoring & Energy Control</p>
            </header>

            {/* 2X2 GRID ALIGNMENT */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl mx-auto">
              {colleges.map((college, i) => {
                const currentProjId = selectedProject[college.name] || "cems";
                const activeProj = college.projects.find(p => p.id === currentProjId);
                const disabled = !activeProj?.url;

                return (
                  <div key={i} className="group relative" style={{ animationDelay: `${i * 100}ms` }}>
                    <div className="glass-hero rounded-[2.5rem] p-8 border border-white/10 shadow-2xl relative transition-all duration-500 hover:border-white/30 hover:scale-[1.02]">
                      
                      <div className="flex justify-between items-start mb-10">
                        <div className="space-y-3">
                          <div className={`text-[9px] font-black tracking-[0.2em] px-3.5 py-1 rounded-full border inline-block uppercase 
                            ${college.status === 'ONLINE' ? 'bg-emerald-500/20 text-white border-emerald-500/30' : 'bg-rose-500/20 text-white border-rose-500/30'}`}>
                            {college.status}
                          </div>
                          <h3 className="text-4xl font-black tracking-tighter text-white uppercase italic">{college.name}</h3>
                          <div className="flex items-center gap-2 text-[10px] font-bold text-white tracking-[0.1em] opacity-60">
                            <svg className="w-3.5 h-3.5 text-amber-500" fill="currentColor" viewBox="0 0 20 20"><path d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9z"/></svg>
                            {college.location}
                          </div>
                        </div>
                        <div className="p-3 bg-white/5 rounded-2xl border border-white/5 shadow-inner backdrop-blur-md">
                           <img src={college.logo} alt="" className="h-10 w-auto object-contain opacity-70 group-hover:opacity-100 transition-all duration-500" />
                        </div>
                      </div>

                      {/* SELECTOR SWITCH */}
                      <div className="relative flex bg-black/40 p-1.5 rounded-xl border border-white/10 mb-8">
                         {college.projects.map((proj) => (
                          <button
                            key={proj.id}
                            onClick={() => setSelectedProject(prev => ({ ...prev, [college.name]: proj.id }))}
                            className={`relative z-10 flex-1 py-3 text-[9px] font-black tracking-[0.2em] rounded-lg transition-all uppercase
                              ${currentProjId === proj.id ? "text-black" : "text-white opacity-40 hover:opacity-100"}`}
                          >
                            {currentProjId === proj.id && (
                              <div className={`absolute inset-0 bg-gradient-to-r from-amber-400 to-orange-500 rounded-lg z-[-1] shadow-xl`} />
                            )}
                            {proj.label}
                          </button>
                        ))}
                      </div>

                      <button
                        disabled={disabled}
                        onClick={() => handleLaunch(college)}
                        className={`w-full py-5 rounded-2xl font-black text-[11px] tracking-[0.4em] uppercase transition-all flex items-center justify-center gap-4 border
                          ${disabled 
                            ? "bg-white/2 border-white/5 text-white/20 cursor-not-allowed" 
                            : "bg-white/5 text-white border-white/10 hover:bg-white hover:text-black hover:border-white shadow-xl active:scale-[0.98]"}`}
                      >
                        {disabled ? "ACCESS DENIED" : "INITIALIZE LINK"}
                        {!disabled && <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M13 7l5 5m0 0l-5 5m5-5H6"/></svg>}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      <style>{`
        .glass-hero { background: rgba(255, 255, 255, 0.03); backdrop-filter: blur(40px) saturate(200%); -webkit-backdrop-filter: blur(40px) saturate(200%); }
        
        @keyframes mesh {
          0% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(5%, -8%) scale(1.05); }
          66% { transform: translate(-5%, 5%) scale(0.95); }
          100% { transform: translate(0, 0) scale(1); }
        }
        
        @keyframes pageIn {
          from { opacity: 0; transform: translateY(40px); filter: blur(10px); }
          to { opacity: 1; transform: translateY(0); filter: blur(0); }
        }

        .animate-mesh { animation: mesh 14s infinite ease-in-out; }
        .animate-pageIn { animation: pageIn 1s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
        .animation-delay-2000 { animation-delay: 2s; }
        .animation-delay-4000 { animation-delay: 4s; }
        
        .shadow-3xl { box-shadow: 0 40px 100px -20px rgba(0,0,0,0.8); }
      `}</style>
    </div>
  );
};

export default Livepage;